import { Link } from "react-router-dom";
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

export default function LatestBlog() {
    // Blog data
    const blogPosts = [
        {
            id: 1,
            image: "/images/course-drums.jpg",
            title: "The Future of Music Education",
            category: "Education",
            excerpt: "Discover how technology is transforming the way we learn and teach music in the digital age.",
            date: "March 15, 2024"
        },
        {
            id: 2,
            image: "/images/course-piano.jpg",
            title: "Mastering Piano Techniques",
            category: "Piano",
            excerpt: "Essential techniques and exercises to improve your piano playing skills and musical expression.",
            date: "March 12, 2024"
        },
        {
            id: 3,
            image: "/images/course-vocal.jpg",
            title: "Vocal Training Fundamentals",
            category: "Vocal",
            excerpt: "Learn the fundamental principles of vocal training and how to develop your unique voice.",
            date: "March 10, 2024"
        },
        {
            id: 4,
            image: "/images/course-drums.jpg",
            title: "Guitar Learning Guide",
            category: "Guitar",
            excerpt: "A comprehensive guide for beginners starting their guitar learning journey with expert tips.",
            date: "March 8, 2024"
        }
    ];

    // Slider settings for mobile
    const sliderSettings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        pauseOnHover: true,
        arrows: true,
        responsive: [
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: true,
                    dots: false
                }
            }
        ]
    };

    return (
        <>
            <section id="blog-section">
                <div className="blog-header">
                    <h2 className="section-title">Our Latest Blog</h2>
                </div>

                {/* Desktop Grid Layout */}
                <div className="blog-grid desktop-blog-grid">
                    {blogPosts.map((post) => (
                        <div key={post.id} className="blog-item">
                            <div className="blog-image">
                                <img src={post.image} alt={post.title} />
                                <div className="blog-overlay">
                                    <div className="blog-content">
                                        <h3 className="blog-title">{post.title}</h3>
                                        <span className="blog-category">{post.category}</span>
                                        <p className="blog-excerpt">{post.excerpt}</p>
                                        <div className="blog-meta">
                                            <span className="blog-date">{post.date}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                {/* Mobile Slider Layout */}
                <div className="blog-slider mobile-blog-slider">
                    <Slider {...sliderSettings}>
                        {blogPosts.map((post) => (
                            <div key={post.id} className="blog-slide">
                                <div className="blog-item">
                                    <div className="blog-image">
                                        <img src={post.image} alt={post.title} />
                                        <div className="blog-overlay">
                                            <div className="blog-content">
                                                <h3 className="blog-title">{post.title}</h3>
                                                <span className="blog-category">{post.category}</span>
                                                <p className="blog-excerpt">{post.excerpt}</p>
                                                <div className="blog-meta">
                                                    <span className="blog-date">{post.date}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </Slider>
                </div>

                <span className="duration"><Link to="/blog">View All</Link></span>
            </section>
        </>
    );
} 